import isNil from 'lodash/isNil';

export default function isCurrent(section, currentTime) {
  return (
    !isNil(section.start) &&
    section.start <= currentTime &&
    (section.end > currentTime || section.end === null)
  );
}
